/**
 * Утилиты для проверки прав доступа к школе
 */

/**
 * Проверяет, является ли текущий пользователь владельцем школы
 * @param {Object} school - Объект школы с полями psych и invitedPsychs
 * @param {string} currentUserId - ID текущего пользователя
 * @returns {boolean} - true если пользователь владелец школы
 */
export const isSchoolOwner = (school, currentUserId) => {
    if (!school || !currentUserId) {
        return false;
    }
    
    // Сравниваем ID владельца школы с текущим пользователем
    return school.psych === currentUserId || school.psych?._id === currentUserId;
};

/**
 * Проверяет, является ли текущий пользователь приглашенным психологом
 * @param {Object} school - Объект школы с полями psych и invitedPsychs
 * @param {string} currentUserId - ID текущего пользователя
 * @returns {boolean} - true если пользователь приглашен в школу
 */
export const isInvitedPsychologist = (school, currentUserId) => {
    if (!school || !currentUserId || !school.invitedPsychs) {
        return false;
    }
    
    // Проверяем, есть ли пользователь в списке приглашенных
    return school.invitedPsychs.some(psychId => {
        if (typeof psychId === 'string') {
            return psychId === currentUserId;
        }
        return psychId?._id === currentUserId;
    });
};

/**
 * Проверяет, имеет ли пользователь доступ к школе (владелец или приглашенный)
 * @param {Object} school - Объект школы с полями psych и invitedPsychs
 * @param {string} currentUserId - ID текущего пользователя
 * @returns {boolean} - true если пользователь имеет доступ к школе
 */
export const hasSchoolAccess = (school, currentUserId) => {
    return isSchoolOwner(school, currentUserId) || isInvitedPsychologist(school, currentUserId);
};

/**
 * Проверяет, может ли пользователь редактировать школу
 * Редактировать могут только владельцы
 * @param {Object} school - Объект школы с полями psych и invitedPsychs
 * @param {string} currentUserId - ID текущего пользователя
 * @returns {boolean} - true если пользователь может редактировать школу
 */
export const canEditSchool = (school, currentUserId) => {
    return isSchoolOwner(school, currentUserId);
};

/**
 * Проверяет, может ли пользователь приглашать других психологов
 * Приглашать могут только владельцы
 * @param {Object} school - Объект школы с полями psych и invitedPsychs
 * @param {string} currentUserId - ID текущего пользователя
 * @returns {boolean} - true если пользователь может приглашать психологов
 */
export const canInvitePsychologists = (school, currentUserId) => {
    return isSchoolOwner(school, currentUserId);
};
